import Raven from 'raven-js';
import { useCallback, useEffect, useRef } from 'react';
import { useSendOnCopilotChannel } from '../channel/hooks/useSendOnCopilotChannel';
import { useIsAssistantBusy } from '../magpie/hooks/useIsAssistantBusy';
export const useSendMessageFromAppToCopilot = () => {
  const sendCopilotMessageOnChannel = useSendOnCopilotChannel('SEND_MESSAGE');
  const {
    isAssistantBusy
  } = useIsAssistantBusy();
  const isAssistantBusyRef = useRef(isAssistantBusy);
  isAssistantBusyRef.current = isAssistantBusy;
  const pendingMessageRef = useRef(null);
  useEffect(() => {
    if (!isAssistantBusy && pendingMessageRef.current) {
      sendCopilotMessageOnChannel(pendingMessageRef.current);
      pendingMessageRef.current = null;
    }
  }, [isAssistantBusy, sendCopilotMessageOnChannel]);
  return useCallback(data => {
    if (!data.messageText) return;
    if (!isAssistantBusyRef.current) {
      sendCopilotMessageOnChannel(data);
    } else {
      if (pendingMessageRef.current) {
        // we'll only queue one message at a time
        Raven.captureMessage('Message not sent to copilot because assistant is busy', {
          level: 'warning',
          extra: {
            message: pendingMessageRef.current
          }
        });
      }
      pendingMessageRef.current = data;
    }
  }, [sendCopilotMessageOnChannel]);
};
export const useSendCollaborationPluginContext = () => {
  const sendCopilotMessageOnChannel = useSendOnCopilotChannel('COLLABORATE_COPILOT_SET_CONTEXT');
  return useCallback(({
    plugin,
    extraIntentProperties
  }) => {
    sendCopilotMessageOnChannel({
      plugin,
      extraIntentProperties: extraIntentProperties || {}
    });
  }, [sendCopilotMessageOnChannel]);
};
export const useSendCollaborationAction = () => {
  const sendCopilotActionOnChannel = useSendOnCopilotChannel('SEND_ACTION');
  return useCallback(({
    messageAction,
    messageMetaInfo,
    customAssistantData,
    customAssistantId
  }) => {
    sendCopilotActionOnChannel({
      messageAction,
      messageMetaInfo,
      customAssistantData,
      customAssistantId
    });
  }, [sendCopilotActionOnChannel]);
};
export const useAskUserForMoreInfo = () => {
  const sendCopilotActionOnChannel = useSendOnCopilotChannel('PROMPT_USER_FOR_MORE_INFO');
  return useCallback(({
    messageAction,
    messageMetaInfo,
    promptData
  }) => {
    sendCopilotActionOnChannel({
      messageAction,
      messageMetaInfo,
      promptData
    });
  }, [sendCopilotActionOnChannel]);
};